import { connect } from 'react-redux';
import { get } from 'lodash';

import { saveMiddleware } from 'app/developer-v3/store/build/actions';
import {
  selectDefinitionOverride,
  selectIsAppVersionSaving,
} from 'app/developer-v3/store/selectors';

import Middleware from './Middleware';

const mapStateToProps = state => ({
  middleware: {
    beforeRequest: get(
      selectDefinitionOverride(state),
      ['beforeRequest', '0', 'source'],
      ''
    ),
    afterResponse: get(
      selectDefinitionOverride(state),
      ['afterResponse', '0', 'source'],
      ''
    ),
  },
  isSaving: selectIsAppVersionSaving(state),
});

export default connect(mapStateToProps, { saveMiddleware })(Middleware);
